import React from 'react';
import { Box } from '@mui/material';
import CurrencySpecificFinancialCenter from '../components/financial/CurrencySpecificFinancialCenter';

/**
 * Page autonome pour la vue financière propriétaire
 * Accès direct sans passer par FinancialHubPage
 */
const OwnerFinancialPage = () => {
  return (
    <Box sx={{ 
      minHeight: 'calc(100vh - 230px)',
      position: 'relative',
      paddingBottom: '20px',
      display: 'flex', 
      flexDirection: 'column'
    }}>
      <Box sx={{ flexGrow: 1 }}>
        <CurrencySpecificFinancialCenter key="owner-financial-center" />
      </Box>
    </Box>
  );
};

export default OwnerFinancialPage;
